export default __webpack_public_path__ + "locales/el-GR/Ldap.json?hash=27c15415a3337dd8eaef08f5d495f44e";